// frontend/src/theme/components/reactSelect.js


export const reactSelectStyles = {
  // Bu, bileşenin farklı parçalarını tanımlar
  parts: ['container', 'control', 'menu', 'option', 'multiValue', 'singleValue', 'input'],
  
  // baseStyle, tüm varyantlar için geçerli olan temel stilleri tanımlar
  baseStyle: {
    // .react-select__control gibi class'lara stil uygulamak yerine,
    // chakra-react-select'in sağladığı "part" isimlerini kullanırız.
    control: {
      // _light ve _dark kullanarak renk modu stillerini tanımlıyoruz
      _light: {
        bg: 'white',
        borderColor: 'gray.200',
      },
      _dark: {
        bg: 'gray.700',
        borderColor: 'gray.600',
      },
      _hover: {
        _light: { borderColor: 'gray.300' },
        _dark: { borderColor: 'gray.500' },
      },
      _focusVisible: {
        _light: { borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' },
        _dark: { borderColor: 'brand.300', boxShadow: '0 0 0 1px var(--chakra-colors-brand-300)' },
      }
    },
    menu: {
      _light: { bg: 'white' },
      _dark: { bg: 'gray.700' },
    },
    option: {
      _hover: {
        _light: { bg: 'gray.100' },
        _dark: { bg: 'gray.600' },
      },
      _focus: {
        _light: { bg: 'gray.100' },
        _dark: { bg: 'gray.600' },
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
      },
    },
    input: {
      _light: { color: 'gray.800' },
      _dark: { color: 'whiteAlpha.900' },
    },
    singleValue: {
      _light: { color: 'gray.800' },
      _dark: { color: 'whiteAlpha.900' },
    },
    multiValue: {
      _light: { bg: 'gray.100' },
      _dark: { bg: 'gray.600' },
    }
  },
};